import UsersLibraryPage from '@/modules/admin/users/users-library-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/admin/users')({
  component: UsersLibraryPage,
});
